import { useAtomValue } from 'jotai';
import { useSidePanel } from '../side-panel-provider';
export const useSelectedAnnotationIds = () => {
  const {
    selectedAnnotationIdsAtom
  } = useSidePanel();
  const selectedAnnotationIds = useAtomValue(selectedAnnotationIdsAtom);
  return selectedAnnotationIds;
};